import { render, staticRenderFns } from "./ChartLegend.vue?vue&type=template&id=b6241d34&scoped=true"
import script from "./ChartLegend.vue?vue&type=script&lang=js"
export * from "./ChartLegend.vue?vue&type=script&lang=js"
import style0 from "./ChartLegend.vue?vue&type=style&index=0&id=b6241d34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6241d34",
  null
  
)

export default component.exports